import { gql } from '@apollo/client';

// TODO: Remove mock-response assumptions in consumers once the Jira integration BE is live.

const JIRA_INTEGRATION_SETUP_FIELDS = gql`
  fragment JiraIntegrationSetupFields on JiraIntegrationSetup {
    mode
    currentStep
    instanceUrl
    appVersion
    selectedSiteId
    selectedSpaceIds
    error {
      title
      message
    }
    reconnectSummary {
      connectedSpacesCount
    }
    steps {
      step
      status
      title
      description
      detail
    }
    availableSites {
      id
      url
      selectable
    }
    availableSpaces {
      id
      name
      openTicketsCount
      selected
    }
    primaryAction {
      label
      actionType
      url
      loading
      disabled
    }
  }
`;

export const GET_JIRA_INTEGRATION_SETUP = gql`
  ${JIRA_INTEGRATION_SETUP_FIELDS}
  query jiraIntegrationSetup($args: JiraIntegrationSetupInput) {
    jiraIntegrationSetup(args: $args) {
      ...JiraIntegrationSetupFields
    }
  }
`;

export const QL_JIRA_INTEGRATION_SETUP_ACTION = gql`
  ${JIRA_INTEGRATION_SETUP_FIELDS}
  mutation jiraIntegrationSetupAction($args: JiraIntegrationSetupActionInput!) {
    jiraIntegrationSetupAction(args: $args) {
      ...JiraIntegrationSetupFields
    }
  }
`;

export const QL_JIRA_INTEGRATION_DISCONNECT = gql`
  mutation jiraIntegrationDisconnect {
    jiraIntegrationDisconnect {
      status
      instanceUrl
      spacesCount
      lastUpdated
    }
  }
`;

export const QL_JIRA_INTEGRATION_TEST_CONNECTION = gql`
  mutation jiraIntegrationTestConnection {
    jiraIntegrationTestConnection {
      success
      error
    }
  }
`;

export const GET_JIRA_INTEGRATION = gql`
  query jiraIntegration {
    jiraIntegration {
      status
      instanceUrl
      spacesCount
      lastUpdated
      connectionHealth {
        instanceUrl
        connectionStatusLabel
        oauthSummary
        metrics {
          connectedSpaces
          lastSync
        }
        systemChecks {
          id
          title
          description
          status
        }
        connectedSpaces {
          id
          name
          projectKey
          category
          openTicketsCount
          linkedTicketsCount
          status
          iconColorIndex
          ticketDefaults {
            issueType
            priority
            defaultAssignee
            issueTypeOptions
            priorityOptions
            assigneeOptions
          }
        }
        addableSpaces {
          id
          name
          openTicketsCount
          selected
        }
      }
    }
  }
`;

export const QL_JIRA_INTEGRATION_DELETE_CONNECTED_SPACE = gql`
  mutation jiraIntegrationDeleteConnectedSpace($args: JiraIntegrationDeleteConnectedSpaceInput!) {
    jiraIntegrationDeleteConnectedSpace(args: $args) {
      success
      error
    }
  }
`;

export const QL_JIRA_INTEGRATION_ADD_CONNECTED_SPACE = gql`
  mutation jiraIntegrationAddConnectedSpace($args: JiraIntegrationAddConnectedSpaceInput!) {
    jiraIntegrationAddConnectedSpace(args: $args) {
      success
      error
    }
  }
`;

export const QL_JIRA_INTEGRATION_UPDATE_CONNECTED_SPACE_TICKET_DEFAULTS = gql`
  mutation jiraIntegrationUpdateConnectedSpaceTicketDefaults(
    $args: JiraIntegrationUpdateConnectedSpaceTicketDefaultsInput!
  ) {
    jiraIntegrationUpdateConnectedSpaceTicketDefaults(args: $args) {
      success
      error
    }
  }
`;

export const GET_VULNERABILITY_JIRA_TICKETS = gql`
  query vulnerabilityJiraTickets($args: VulnerabilityJiraTicketsInput!) {
    vulnerabilityJiraTickets(args: $args) {
      id
      ticketKey
      projectName
      status
      assignee
      updatedAt
      url
    }
  }
`;

export const QL_JIRA_INTEGRATION_UNLINK_VULNERABILITY_TICKET = gql`
  mutation jiraIntegrationUnlinkVulnerabilityTicket($args: JiraIntegrationUnlinkVulnerabilityTicketInput!) {
    jiraIntegrationUnlinkVulnerabilityTicket(args: $args) {
      success
      error
    }
  }
`;
